import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, toRefs } from 'vue';

import { TimelineStatus } from '@/Analysis/analysis.entity';

// Accepts the synthetic timeline markers as well as real workflow statuses; both resolve their
// label from `status.*` and their colour from a `status_*` class.

export default /*#__PURE__*/_defineComponent({
  __name: 'AnalysisStatusBadge',
  props: {
    status: {
        type: String as PropType<TimelineStatus>,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const { status } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['tag', `status_${_unref(status).toLowerCase()}`])
  }, _toDisplayString(_ctx.$t(`status.${_unref(status)}`)), 3))
}
}

})